<div>
  <video #video></video>
</div>
